import { Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSnackbar } from '@/hooks/use-snackbar';

const SnackbarCommon = () => {
  const { open, message, closeSnackbar, type, vertical, horizontal, persist } = useSnackbar();

  const backgroundColor = {
    success: {
      backgroundColor: '#cfeddc',
      color: '#333745',
    },
    error: {
      backgroundColor: '#fcd9d9',
      color: '#333745',
    },
  };
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={closeSnackbar}
      message={message}
      autoHideDuration={persist ? null : 5000}
      key='helper_snackbar'
      sx={{
        '& .MuiSnackbarContent-root': {
          maxWidth: '500px',
          backgroundColor: backgroundColor[type].backgroundColor,
          color: backgroundColor[type].color,
          fontWeight: 700,
          whiteSpace: 'pre-line',
        },
        '& .MuiSnackbarContent-message': {
          maxWidth: 'calc(100% - 38px)',
          maxHeight: '160px',
          overflow: 'auto',
        },
      }}
      action={
        <IconButton size='small' aria-label='close' color='inherit' onClick={closeSnackbar}>
          <CloseIcon fontSize='small' />
        </IconButton>
      }
    />
  );
};

export default SnackbarCommon;
